export function stringIsDefinedAndNotEmpty(value) {
	let isDefined = false;

	if (value !== undefined && value !== null && value !== '') {
		isDefined = true;
	}

	return isDefined;
}

export function objectIsDefinedAndHasProperty(obj, propName) {
	let isDefined = false;

	if (
		obj !== undefined &&
		obj !== null &&
		Object.hasOwnProperty.call(obj, propName)
	) {
		isDefined = true;
	}

	return isDefined;
}
